import styled from 'styled-components'

import { FireLink, FireLinkProps } from '@nx/fire/link'

export const ShareSheetWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-top: 10px;
  gap: 10px 30px;
`

export const SocialNetwork = styled(FireLink)<FireLinkProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.colours.primary.black};

  &:focus,
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colours.primary.primary};
    text-decoration: underline;
  }
`

export const SocialNetworkIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  margin-right: 5px;
`
